export default __webpack_public_path__ + "static/media/Teacher4.ed2bd397.jpg";